import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {NotificationService} from 'src/app/services/notification.service';
import {SettingsService, SmtpDetail} from '../settings.service';
import {EncryptionService} from 'src/app/services/encryption.service';

@Component({
    selector: 'app-smtp-config',
    templateUrl: './smtp-config.component.html',
    styleUrls: ['./smtp-config.component.scss'],
    standalone: false
})
export class SmtpConfigComponent implements OnInit {
	Default: SmtpDetail;
	NewConfig: SmtpDetail;
	EmailConfirmPassword: string = '';
	infoPopupMessage: string = '';
	showInfoPopup: boolean = false;

	constructor(
		private settingsService: SettingsService,
		private notificationService: NotificationService,
		private titleService: Title,

		private _encryptionService: EncryptionService
	) {}

	passwordComparison = () => {
		return this.NewConfig.smtpPassword;
	};
	hash;
	ngOnInit() {
		this.titleService.setTitle('Mail Configuration');
		this.settingsService.GetSmtpDetail().subscribe(
			(data) => {
				if (data != null) {
					this.Default = data.default;
					this.NewConfig = data.newConfig;
					this.NewConfig.isUsed = !this.NewConfig.isUsed;
				} else {
					this.notificationService.error('something went wrong. please try again later.');
				}
			},
			(err) => {
				this.notificationService.error(err);
			}
		);
	}

	ChangeDefault(e) {
		this.NewConfig.isUsed = !this.NewConfig.isUsed;
	}

	onFormSubmit(e) {
		let PassOld = this.NewConfig.smtpPassword;

		let passData = Object.assign({}, this.NewConfig);
		passData.isUsed = !passData.isUsed;
		passData.smtpPassword = this._encryptionService.encryptType(this.NewConfig.smtpPassword);
		this.settingsService
			.UpdateSmtpDetails(passData)
			.toPromise()
			.then((data) => {
				this.NewConfig.smtpPassword = PassOld;
				if (data != null) {
					if (data.flag > 0) {
						this.NewConfig.smtpPassword="";
						this.EmailConfirmPassword="";
						this.notificationService.success(data.msg);
					} else {
						this.notificationService.error(data.msg);
					}
				} else {
					this.notificationService.error('something went wrong. please try again later.');
				}
			});
	}
}
